import fastDeelEqual from 'fast-deep-equal'
import type { __ImageItemFragment, __ProductListingBoxFragment } from '../generated/graphql'

export function isEqualSimple<T>(a: T, b: T): boolean {
  return fastDeelEqual(a, b)
}

type ScreenValue = 'scrollTop' | 'scrollLeft' | 'innerWidth' | 'innerHeight'

function myWindowGet(type: ScreenValue): number | undefined {
  if (!import.meta.browser) return undefined
  else if (type === 'scrollTop') return window.visualViewport?.pageTop || window.pageYOffset || document.documentElement.scrollTop || window.scrollY
  else if (type === 'scrollLeft') return window.pageXOffset || document.documentElement.scrollLeft || window.scrollX
  else if (type === 'innerWidth') return window.visualViewport?.width || window.innerWidth || document.documentElement.clientWidth
  else if (type === 'innerHeight') return window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight
  else if (helpers.never(type, () => true)) return undefined
}

export function myWindow<T = undefined>(type: ScreenValue, fb?: T): number | T {
  const val = myWindowGet(type)
  return helpers.isDef(val) ? val : (fb as T)
}

export function myScreen(): { h: number; w: number } {
  return {
    h: (window.innerHeight || document.documentElement.clientHeight) ?? 967,
    w: (window.innerWidth || document.documentElement.clientWidth) ?? 1728,
  }
}

type ScreenValue2 = 'scrollTop' | 'scrollLeft' | 'offsetWidth' | 'scrollHeight' | 'height' | 'offsetHeight' | 'offsetTop' | 'offsetLeft' | 'scrollWidth'

function myElemGet(el: HTMLElement, type: ScreenValue2): number | undefined {
  if (!import.meta.browser) return undefined
  else if (type === 'scrollTop') return el.scrollTop
  else if (type === 'scrollLeft') return el.scrollLeft
  else if (type === 'scrollWidth') return el.scrollWidth
  else if (type === 'scrollHeight') return el.scrollHeight
  else if (type === 'offsetWidth') return el.offsetWidth || el.clientWidth
  else if (type === 'offsetHeight') return el.offsetHeight || el.clientHeight
  else if (type === 'offsetLeft') return el.offsetLeft || el.clientLeft
  else if (type === 'offsetTop') return el.offsetTop || el.clientTop
  else if (type === 'height') {
    const styles = window.getComputedStyle(el)
    return Math.ceil((myElemGet(el, 'offsetHeight') || 0) + Number.parseFloat(styles.marginTop) + Number.parseFloat(styles.marginBottom))
  } else if (helpers.never(type, () => true)) return undefined
}

export function myElem<T = undefined>(el: VueComponent | None, type: ScreenValue2, fb?: T): number | T {
  const e2 = helpers.getHTMLElement(el)
  const val = e2 ? myElemGet(e2, type) : undefined
  return helpers.isDef(val) ? val : (fb as T)
}

export function getListingImg(m: None | Partial<Pick<__ProductListingBoxFragment, 'images' | 'img1'>> | { imageBox?: None | __ImageItemFragment }): undefined | __ImageItemFragment {
  if (m && 'imageBox' in m) return m.imageBox || undefined
  if (m && 'images' in m) return m?.images?.find((i) => i._id === m.img1) || m?.images?.at(0) || undefined
  return undefined
}
